<template>
  <div class="error">
    <span class="error-text">{{ error.message ? error.message : error }}</span>
    <vbutton
      class="button"
      label="responses.tags.distributionRules.refresh"
      @click="$emit('reload')"/>
  </div>
</template>
<script>
  export default {
    name: 'error-view',
    props: {
      error: {
        type: [Error, String, Object],
        required: true,
      }
    }
  }
</script>
<style scoped lang="scss">
  @import "@/styles/colors.scss";
  
  .error {
    padding: 5px 0;
    .error-text {
      font-size: 14px;
      color: $red-color;
    }
    .button {
      margin-left: 5px;
    }
  }
</style>
